/**
 * 점검 목록 새로고침 트리거 스토어
 *
 * useState 기반의 useInspectionListPage에서 WebSocket 이벤트로
 * 새로고침을 트리거하기 위한 간단한 스토어
 */

import { create } from 'zustand';

interface InspectionListRefreshStore {
  /** 새로고침 트리거 카운터 (변경될 때마다 새로고침) */
  refreshTrigger: number;
  /** 새로고침 트리거 */
  triggerRefresh: () => void;
}

export const useInspectionListRefreshStore = create<InspectionListRefreshStore>((set) => ({
  refreshTrigger: 0,
  triggerRefresh: () => set((state) => ({ refreshTrigger: state.refreshTrigger + 1 })),
}));
